export default __webpack_public_path__ + "img/fondoRed.5608f574.jpg";